import AddToComparison from '@app/Comparison/Add'
import ComparisonView from '@app/Comparison/View'
import ComparisonPreview from '@app/Comparison/Preview'

export default function plugin(Vue) {
  Vue.component(AddToComparison.name, AddToComparison)
  Vue.component(ComparisonView.name, ComparisonView)
  Vue.component(ComparisonPreview.name, ComparisonPreview)
}
